export const careerData = [
  {
    title: "FRONTEND DEVELOPER",
    positions: [
      {
        company: "The Shortcut, Helsinki",
        period: "Jan 2020 - ongoing",
        desc:
          "Developing responsive user interface of the company's website with JavaScript and React.js, SCSS, fetching data from WordPress and Eventbrite APIs. Monitoring GitHub based collaboration. Teamwork with designers and marketers using Agile approach and Trello boards. Deployment of MVPs on Firebase platform.",
        link: "https://github.com/OlSavMe/React-Shortcut-Website",
        desctwo:
          "Creating JSON data and visual charts for the interface of the Database Management System with React.js, react-chartjs-2, using Docker Containers for local dev environment. Teamwork with a backend developer and data analysts.",
      },
      {
        company: "Haaga-Helia & Webscale Oy, Helsinki",
        period: "Aug 2019 - Dec 2019",
        desc:
          "Developing user interface of a game web app with React.js, React Material-UI, qr scanner library, react-router, Axios, using Docker Containers with pgAdmin for local dev environment. Team work with front- and backend developers, designers in Scrum sprints, using git version control and CircleCI for continuous delivery and automated testing.",
        link: "",
        desctwo: "",
      },
    ],
  },
  {
    title: "UX DESIGNER",
    positions: [
      {
        company: "DIGITAL PROTOTYPING WEEK by The Shortcut, Helsinki",
        period: "Oct 2019",
        desc:
          "Developing design and prototype of a volunteer matching mobile app with Figma. Teamwork with the other UX designer.",
        link:
          "https://www.figma.com/proto/P9IeRig2R8qgdylrxklhUC/Prototyping-UI-Kit-(Copy)?node-id=311%3A263&scaling=scale-down",
        desctwo: "",
      },
      {
        company: "The winner project of the RIGA MUDDIE WEEK, Riga",
        period: "Apr 2019",
        desc:
          "Developing design and prototype for a healthcare application with Figma in a multidisciplinary team.",
        link:
          "https://www.figma.com/proto/MXr37r7aAN7txw7QVJFY03/READY-migraine-map-vol2-(Copy)?node-id=29%3A6&scaling=scale-down",
        desctwo: "",
      },
    ],
  },
  {
    title: "ENGLISH TECHNICAL TRANSLATOR",
    positions: [
      {
        company:
          "Astaldi Ictas, Josef Gartner, Paroc, Lemminkäinen, Globus, freelance, Tver - Saint-Petersburg",
        period: "2010 - 2016",
        desc:
          "Translation, interpreting, writing, proofreading in construction and manufacturing industries.",
        link: "",
        desctwo: "",
      },
    ],
  },
  {
    title: "SEO COPYWRITER",
    positions: [
      {
        company: "Online-marketing agencies",
        period: "2011 - 2012",
        desc:
          "Advertising, web-content creation, SEO copywriting, translation, editing, negotiations with clients, moderation of an online shoe store community in a social network",
        link: "",
        desctwo: "",
      },
    ],
  },
];

export const portfolioSelectData = [
  {
    value: "Only deployed",
    label: "Only deployed",
  },
  {
    value: "Only React",
    label: "Only React",
  },
  {
    value: "Java",
    label: "Java",
  },
  {
    value: "JavaScript",
    label: "JavaScript | ReactJS | React Native",
  },
  {
    value: "HTML",
    label: "HTML | CSS | JQuery | BootStrap",
  },
  {
    value: "All repositories",
    label: "All repositories",
  },
];
